export default __webpack_public_path__ + "static/media/diaphragm.61cf6250.svg";